<template>
  <span>
    <s-tooltip v-if="showTip && tip" :transfer="true" :content="tip" placement="bottom">
      <slot name="content"></slot>
    </s-tooltip>
    <slot name="content" v-else></slot>
  </span>
</template>

<script>
export default {
  name: 'disabled-tips',
  props: {
    showTip: {
      type: Boolean,
      default() {
        return false
      },
    },
    tip: {
      type: String,
      default() {
        return ''
      },
    },
  },
}
</script>
